module.exports = __webpack_public_path__ + "img/salmon_rice_paper_snack.3a90a9ec.jpg";